import { useEffect, useState } from 'react';

export function useTimer(initialSeconds: number, resetKey?: number) {
  const [secondsLeft, setSecondsLeft] = useState<number>(initialSeconds);

  useEffect(() => {
    setSecondsLeft(initialSeconds);
  }, [initialSeconds, resetKey]);

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [resetKey, initialSeconds]);

  return secondsLeft;
}

export function useSimpleTimer(durationSeconds: number) {
  const [secondsLeft, setSecondsLeft] = useState<number>(durationSeconds);

  useEffect(() => {
    setSecondsLeft(durationSeconds);
  }, [durationSeconds]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const reset = () => {
    setSecondsLeft(durationSeconds);
  };

  return { secondsLeft, reset } as const;
}

export function formatTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const remainingSeconds = (seconds % 60).toString().padStart(2, '0');

  return `${minutes}:${remainingSeconds}`;
}

export function getMinutes(seconds: number): string {
  return Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
}

export function getRemainingSeconds(seconds: number): string {
  return (seconds % 60).toString().padStart(2, '0');
}
